const VisionAndMission = () => {
  return (
   <>
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 relative overflow-hidden">
        {/* Luxury background elements */}
        <div className="absolute inset-0"></div>
        <div className="absolute top-0 left-0 right-0 h-16 sm:h-32 bg-gradient-to-b from-white to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-16 sm:h-32 bg-gradient-to-t from-white to-transparent"></div>

        {/* Decorative elements - hidden on mobile */}
        <div className="absolute left-0 top-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-30 hidden sm:block"></div>
        <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-primary to-transparent opacity-30 hidden sm:block"></div>
        <div className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-30 hidden sm:block"></div>
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-primary to-transparent opacity-30 hidden sm:block"></div>

        <div className="container mx-auto px-4 relative z-10">
          {/* Elegant section heading - responsive spacing and sizes */}
          <div className="max-w-3xl mx-auto text-center mb-10 sm:mb-16 md:mb-20">
            <div className="inline-block">
              <div className="flex items-center justify-center mb-3">
                <div className="h-px w-6 sm:w-12 bg-primary opacity-50"></div>
                <span className="px-2 sm:px-4 text-xs sm:text-sm uppercase tracking-widest font-futura text-primary">
                  The Essence of Takeaya
                </span>
                <div className="h-px w-6 sm:w-12 bg-primary opacity-50"></div>
              </div>
              <h2 className="font-ivyMode text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary leading-tight mb-4 sm:mb-6">
                Vision{" "}
                <span className="inline-block mx-2 sm:mx-4 text-primary opacity-30">
                  |
                </span>{" "}
                Mission
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto font-futura text-sm sm:text-base">
                Defining our path to excellence and guiding every decision we
                make in creating extraordinary experiences.
              </p>
            </div>
          </div>

          {/* Horizontal Showcase Design - responsive margins and padding */}
          <div className="relative mb-16 sm:mb-20 md:mb-24 lg:mb-32">
            <div className="absolute -left-4 -top-4 w-16 h-16 sm:w-20 sm:h-20 hidden sm:block">
              <svg viewBox="0 0 100 100" fill="none">
                <path
                  d="M0,0 L50,0 Q100,0 100,50 L100,100 L50,100 Q0,100 0,50 Z"
                  fill="#A3582A"
                  fillOpacity="0.03"
                />
              </svg>
            </div>
            <div className="absolute -right-4 -bottom-4 w-16 h-16 sm:w-20 sm:h-20 hidden sm:block">
              <svg viewBox="0 0 100 100" fill="none">
                <path
                  d="M100,100 L50,100 Q0,100 0,50 L0,0 L50,0 Q100,0 100,50 Z"
                  fill="#A3582A"
                  fillOpacity="0.03"
                />
              </svg>
            </div>

            <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-primary/10 relative p-1">
              {/* Responsive diagonal band */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[110%] h-8 sm:h-16 bg-gradient-to-r from-[#F8F3E9] via-white to-[#F8F3E9] -rotate-3"></div>

              <div className="grid md:grid-cols-2 gap-0 relative">
                {/* Vision Side - stack on mobile */}
                <div className="p-6 sm:p-8 md:p-10 lg:p-16 relative">
                  <div className="absolute top-2 right-2 sm:top-4 sm:right-4 text-primary/10 font-ivyMode text-6xl sm:text-8xl md:text-9xl font-bold">
                    V
                  </div>

                  <h3 className="font-ivyMode text-2xl sm:text-3xl text-primary relative inline-block mb-6 sm:mb-8">
                    Our Vision
                    <div className="absolute -bottom-3 left-0 w-full h-px bg-gradient-to-r from-primary to-transparent"></div>
                  </h3>

                  <div className="mb-6 sm:mb-8 relative font-futura">
                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg relative z-10 text-start pl-4">
                      To become the{" "}
                      <span className="font-medium text-primary">
                        leading tech-powered vacation home provider
                      </span>{" "}
                      in the UAE, offering unforgettable stays powered by
                      innovation, cultural warmth, and a dedication to
                      excellence.
                    </p>
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-primary to-transparent opacity-30"></div>
                  </div>
                </div>

                {/* Mission Side - stack on mobile */}
                <div className="p-6 sm:p-8 md:p-10 lg:p-16 bg-gradient-to-br from-[#F8F3E9]/80 to-white relative">
                  <div className="absolute top-2 right-2 sm:top-4 sm:right-4 text-primary/10 font-ivyMode text-6xl sm:text-8xl md:text-9xl font-bold">
                    M
                  </div>

                  <h3 className="font-ivyMode text-2xl sm:text-3xl text-primary relative inline-block mb-6 sm:mb-8">
                    Our Mission
                    <div className="absolute -bottom-3 left-0 w-full h-px bg-gradient-to-r from-primary to-transparent"></div>
                  </h3>

                  <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8 relative font-futura text-start pl-4">
                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-lg relative z-10">
                      To provide travelers and property owners with{" "}
                      <span className="font-medium text-primary">
                        seamless, smart, and stylish vacation solutions
                      </span>{" "}
                      — enhanced by AI, refined by human touch, and curated with
                      precision, care, and authenticity.
                    </p>
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-primary to-transparent opacity-30"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quote Section - responsive spacing and font sizes */}
          <div className="text-center mb-16 sm:mb-20 md:mb-24 lg:mb-32 max-w-3xl mx-auto relative">
            <div className="absolute -z-10 top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-6xl sm:text-9xl text-primary/5 font-serif">
              "
            </div>
            <div className="absolute -z-10 bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-6xl sm:text-9xl text-primary/5 font-serif rotate-180">
              "
            </div>

            <p className="font-ivyMode text-xl sm:text-2xl md:text-3xl text-primary leading-relaxed mb-4 sm:mb-6 px-4">
              At Takeaya, we don't manage properties; we nurture legacies.
            </p>
            <div className="h-px w-8 sm:w-12 bg-primary opacity-50 mx-auto mb-3 sm:mb-4"></div>
            <p className="text-primary uppercase tracking-wider text-xs sm:text-sm font-futura font-medium">
              Our Philosophy
            </p>
          </div>
        </div>
      </section>
   </>
  );
};

export default VisionAndMission;